import { render, staticRenderFns } from "./_products.tab.vue?vue&type=template&id=10e5c16c&scoped=true"
import script from "./_products.tab.vue?vue&type=script&lang=js"
export * from "./_products.tab.vue?vue&type=script&lang=js"
import style0 from "./_products.tab.vue?vue&type=style&index=0&id=10e5c16c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e5c16c",
  null
  
)

export default component.exports